import { faMagnifyingGlass } from '@fortawesome/pro-light-svg-icons';
import Dropdown from 'Components/Atoms/Dropdown/Dropdown';
import DropdownEmpty from 'Components/Atoms/Dropdown/DropdownEmpty/DropdownEmpty';
import DropdownItem from 'Components/Atoms/Dropdown/DropdownItem/DropdownItem';
import DropdownLoader from 'Components/Atoms/Dropdown/DropdownLoader/DropdownLoader';
import DropdownSubtitle from 'Components/Atoms/Dropdown/DropdownSubtitle/DropdownSubtitle';
import EntityIcon from 'Components/Atoms/EntityIcon/EntityIcon';
import FontAwesomeIcon from 'Components/Atoms/FontAwesomeIcon/FontAwesomeIcon';
import TextField from 'Components/Atoms/Fields/TextField/TextField';
import { useState } from 'react';
import EntityHelper from 'Services/Settings/Entity/EntityHelper';
import { API_URL } from 'Store/Shared/Middleware/API/Constants';

const GlobalSearch = () => {
    const [value, setValue] = useState('');
    const [isLoading, setLoading] = useState(false);
    const [timer, setTimer] = useState<any>(null);

    const [results, setResults] = useState<any>({
        ids: [],
        entities: {},
        lists: []
    });

    const handleValueChange = (newValue: string): any => {
        if (value === newValue) return;

        if (!isLoading) {
            setLoading(true);
        }

        if (timer) {
            clearTimeout(timer);
            setTimer(null);
        }

        setValue(newValue);
        if (!newValue) {
            setLoading(false);
            return;
        }

        setTimer(
            setTimeout(() => {
                const token: any = localStorage.getItem(window.btoa('accessToken'));
                const accessToken = window.atob(token);

                fetch(`${API_URL}/api/v2/search?entities=candidate,vacancy,contact,business_unit&query=${encodeURIComponent(newValue)}`, {
                    headers: {
                        Authorization: `Bearer ${accessToken}`
                    }
                })
                .then(r => r.json())
                .then(({ data: response }: any) => {
                    const ids = Object.keys(response);
                    setResults({
                        ids: ids,
                        entities: ids.reduce(
                            (acc, curr) => 
                                acc = {
                                    ...acc,
                                    ...response[curr]
                                }
                            , {}
                        ),
                        lists: ids.reduce(
                            (acc, curr) => 
                                acc = {
                                    ...acc,
                                    [curr]: Object.keys(response[curr])
                                }
                            , {}
                        ),
                    });
                    setLoading(false);
                });
            }, 350)
        );
    }

    const getHighlightedText = (text, highlight) => {
        const parts = text.split(new RegExp(`(${highlight.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&')})`, 'gi'));
        return <span>{parts.map(part => part.toLowerCase() === highlight.toLowerCase() ? <b>{part}</b> : part)}</span>;
    }

    return <Dropdown
        trigger={
            <div style={{
                width: '400px'
            }}>
                <TextField
                    iconBefore={<FontAwesomeIcon icon={faMagnifyingGlass} />}
                    size='medium'
                    value={value}
                    onChange={handleValueChange}
                    placeholder='Zoeken door het systeem...'
                />
            </div>
        }
    >
        {
            value.length === 0
            ? ''
            : isLoading && value.length > 0
            ? <div style={{ width: '400px' }}>
                <DropdownLoader />
            </div>
            : !isLoading
            && results?.ids?.length === 0
            && value.length > 0
            ? <div style={{ width: '400px' }}><DropdownEmpty /></div>
            : <div style={{ width: '400px' }}>
                {
                    results
                    .ids
                    .map((entity: any) => <>
                        <DropdownSubtitle
                            iconBefore={
                                <EntityIcon
                                    entity={entity}
                                    size='small'
                                />
                            }
                        >
                            { EntityHelper.getDisplayValueByName(entity) }
                        </DropdownSubtitle>

                        {
                            results
                                .lists[entity]
                                .map((id) =>
                                    <DropdownItem
                                        href={EntityHelper.getEntityRoute(entity, id)}
                                    >
                                        { getHighlightedText(results.entities[id], value) }
                                    </DropdownItem>
                                )
                        }
                    </>
                ) }                    
            </div>
        }
    </Dropdown>;
}

export default GlobalSearch;